module.exports = __webpack_public_path__ + "img/home.b2a0ee79.jpg";